import PropTypes from 'prop-types';

export const OverrideFieldShape = PropTypes.shape({
  value: PropTypes.number,
  overrideValue: PropTypes.number,
});
